import { OPEN_SIGNUP, CLOSE_SIGNUP } from '../actions/Types'


const signUp = (state=false, action) => {
    switch(action.type){
        case OPEN_SIGNUP:
            return true
        case CLOSE_SIGNUP:
            return false
        default:
            return state
    }
}

export default signUp